import React from "react";
import ResultOkIcon from "../../resources/wrappers/ResultOk";
import ResultKoIcon from "../../resources/wrappers/ResultKo";
import "./RegisterDevResult.scss";
import { Button } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";


const RegisterDevResult = (props: any) => {
  const history = useHistory();
  let icon;
  let title;
  let message;

  if (props.location.state?.result === "OK") {
    icon = <ResultOkIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />;
    title = <>Richiesta inviata con successo</>;
    message = <>Attendi che la tua richiesta venga accettata. Riceverai una email di conferma.</>;
    GoogleTagManagerService.getInstance().pushPageEvent(`${history.location.pathname}/success`, 'Richiesta inviata con successo', {});
  } else {
    icon = <ResultKoIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />;
    title = <>Problema durante l'invio della richiesta</>;
    message = <>Abbiamo riscontrato un problema durante l'invio della tua richiesta. Riprova più tardi.</>;
    GoogleTagManagerService.getInstance().pushPageEvent(`${history.location.pathname}/failure`, 'Problema durante l\'invio della richiesta', {});
  }

  const showResultRequeste = () => {
    GoogleTagManagerService.getInstance().pushNewRequest(
      "NUOVA RICHIESTA",
      "submit-button submit-button-after-username",
      "/registerDev",
    );
  }

  return (
    <div className={"register-dev-result-main-container"}>
      <div className={"register-dev-result-page-unauth-main-content"}>
        <div className="result-unauth">
          {icon}
          <p className={"result-unauth-title-error"}>{title}</p>
          <p className="result-unauth-message">{message}</p>
        </div>
      </div>
      {props.location.state?.result !== 'OK' && <Button
        className={"submit-button submit-button-after-username"}
        type={"submit"}
        onClick={() => {
          history.goBack();
          showResultRequeste()
        }}
      >
        NUOVA RICHIESTA
      </Button>}
    </div>
  );
};

export default RegisterDevResult;







